var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseRoundFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close_round_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM4.86193 11.1381C4.60158 10.8777 4.60158 10.4556 4.86193 10.1953L7.05719 8L4.86193 5.80474C4.60158 5.54439 4.60158 5.12228 4.86193 4.86193C5.12228 4.60158 5.54439 4.60158 5.80474 4.86193L8 7.05719L10.1953 4.86193C10.4556 4.60158 10.8777 4.60158 11.1381 4.86193C11.3984 5.12228 11.3984 5.54439 11.1381 5.80474L8.94281 8L11.1381 10.1953C11.3984 10.4556 11.3984 10.8777 11.1381 11.1381C10.8777 11.3984 10.4556 11.3984 10.1953 11.1381L8 8.94281L5.80474 11.1381C5.54439 11.3984 5.12228 11.3984 4.86193 11.1381Z",
    fill: "#9DABBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseRoundFill);
export default __webpack_public_path__ + "static/media/ic-close-round-fill.dafcab4a4159dbcbc61a912dec02a4f8.svg";
export { ForwardRef as ReactComponent };